export default "__VITE_ASSET__CyUfKhgc__"